import { getApps, initializeApp } from 'firebase/app';
import {
  GoogleAuthProvider,
  browserLocalPersistence,
  browserPopupRedirectResolver,
  browserSessionPersistence,
  connectAuthEmulator,
  getAuth,
  indexedDBLocalPersistence,
  initializeAuth,
} from 'firebase/auth';
import { isIos } from '../shared/utils/install-app';
import { firebaseClientConfig } from './firebaseConfig';

// Uygulama ve Auth, Firestore'dan ayrı modülde: her sayfada yüklenen `_app` paketi (oturum
// kancası, bildirim sağlayıcısı) yalnız bunu içe aktarır; Firestore SDK (~230 KB ham) yalnız
// onu kullanan sayfa veya giriş yapmış kullanıcı için `firebaseClient` üzerinden iner.
const useEmulators = process.env.NEXT_PUBLIC_FIREBASE_EMULATORS === 'true';
const emulatorProject = process.env.NEXT_PUBLIC_FIREBASE_EMULATOR_PROJECT;
export const app = getApps().length
  ? getApps()[0]
  : initializeApp(
      useEmulators && emulatorProject?.startsWith('demo-')
        ? { ...firebaseClientConfig, projectId: emulatorProject }
        : firebaseClientConfig,
    );

// `getAuth` tarayıcıda açılır pencere çözücüsünü de başlatır ve her sayfada Google'ın
// iframe/gapi betiklerini (~135 KB, 4 istek) indirir. Çözücü yalnız `signInWithPopup`
// çağrısına verilir (GoogleLogin). Kalıcılık sırası getAuth varsayılanıyla aynıdır;
// mevcut oturumlar korunur. Sunucuda (SSR) ve yeniden başlatmada getAuth kullanılır.
// İstisna: giriş yapmamış iOS ziyaretçisi (Safari ve uygulama WebView'ı). Çözücü geç yüklenirse
// pencere tıklamadan ~1 sn sonra açılır; WebKit bunu engeller ve beyaz ekranda kalınır. Bu
// durumda çözücü baştan hazırlanır (24 Ekim öncesi davranış).
// Giriş/üyelik sayfası doğrudan açıldıysa da (eskimiş `signed_in` ipucuyla) hazırlanır.
const prepareGoogleLogin = () =>
  isIos(navigator.userAgent, navigator.maxTouchPoints) &&
  (window.location.pathname.startsWith('/uyelik/') ||
    // `signed_in` = authSession SIGNED_IN_HINT_COOKIE (o modül _app paketine nookies taşımasın diye).
    !document.cookie.split('; ').includes('signed_in=1'));

const createAuth = () => {
  if (typeof window === 'undefined') return getAuth(app);
  try {
    return initializeAuth(app, {
      persistence: [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence],
      ...(prepareGoogleLogin() ? { popupRedirectResolver: browserPopupRedirectResolver } : {}),
    });
  } catch {
    return getAuth(app);
  }
};

export const auth = createAuth();
export const googleAuthProvider = new GoogleAuthProvider();

// Yalnız yerel uçtan uca test: emulator'a bağlan. Vercel ortamlarında bu değişken tanımlı değildir.
if (useEmulators) {
  const globalFlag = globalThis as { tenisAuthEmulatorConnected?: boolean };
  if (!globalFlag.tenisAuthEmulatorConnected) {
    globalFlag.tenisAuthEmulatorConnected = true;
    connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  }
}
